import { find as _find } from 'lodash';
import { map as _map } from 'lodash';
import { without as _without } from 'lodash';
import FormValidationService from './../../../common/services/FormValidationService';

class VehicleEditController {
  constructor(authService, vehicleService, loadingService, enums, $state, $stateParams, $timeout, lookupService, utilsService, $scope) {
    "ngInject";

    let permissionToCheck;
    if ($stateParams.vehicleId) {
      permissionToCheck = enums.PERMISSION_TYPE.Edit;
    }
    else {
      permissionToCheck = enums.PERMISSION_TYPE.Add;
    }
    if(!authService.validateUser(false, 'Vehicle', permissionToCheck, true)) { return; }

    this.authService = authService;
    this.vehicleService = vehicleService;
    this.loadingService = loadingService;
    this.formValidationService = new FormValidationService();
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.enums = enums;
    this.lookupService = lookupService;
    this.utilsService = utilsService;
    this.$scope = $scope;

    this.state = '';

    this.vehicle = {
      entityId: this.authService.authData.currentLocation.key,
      notes: [],
      extras: [],
      mediaItems: [],
      dueInStock: new Date()
    };

    this.origin = $stateParams.origin;

    this.enumLookupCollection = [];
    this.initializeEnumLookups();

    this.keyValueFields = [
      'Annual Motor Tax',
      'Number of Seats',
      'Number of Doors',
      'Country of Origin',
      'Serial Number',
      'Motor Tax Class',
      'Previous Owners',
      'Current Owners',
      'Tax Expiry Date',
      'NCT Certificate No',
      'UK Reg',
      'UK Previous Owners',
      'NCT Expiry',
      'Date First Registered in Ireland',
      'CO2',
      'NCT Pass Date'
    ];

    this.extras = {};
    
    this.initializeExtras();
  }

  initializeEnumLookups() {
    const ctrl = this;
    ctrl.selectDefaults = {};

    const lookups = ['Color'];
    this.enumLookupCollection = [];

    this.lookupService.lookupEnums(lookups)
      .then(enumLookupCollection => {
        this.enumLookupCollection = enumLookupCollection;
      });
  }

  configureForm() {
    const ctrl = this;

    ctrl.formValidationService.initialize(ctrl.vehicle);

    ctrl.formValidationService.addField({
      fieldName: 'vehicleCondition',
      displayName: 'New or Used',
      type: 'select',
      required: true
    });

    ctrl.formValidationService.addField({
      fieldName: 'registration',
      displayName: 'Registration',
      type: 'text'
    });

    ctrl.formValidationService.addField({
      fieldName: 'brandModelId',
      displayName: 'Make and Model',
      type: 'select',
      required: true
    });

    ctrl.formValidationService.addField({
      fieldName: 'dueInStock',
      displayName: 'Due In Stock',
      type: 'datetime',
      allowPastDate: true
    });

    ctrl.formValidationService.addField({
      fieldName: 'capacity',
      displayName: 'Engine Capacity',
      type: 'int',
      range: {
        min: 0,
        max: 9999
      }
    });

    ctrl.formValidationService.addField({
      fieldName: 'year',
      displayName: 'Year',
      type: 'int',
      range: {
        min: 1950,
        max: new Date().getFullYear() + 2
      }
    });

    ctrl.formValidationService.addField({
      fieldName: 'reconCost',
      displayName: 'Recon Cost',
      type: 'float'
    });
  }

  loadVehicle() {
    const ctrl = this;

    this.configureForm();

    if (ctrl.$stateParams.vehicleId) {
      ctrl.loadingService.showLoading('editVehicle', 'Loading Vehicle ...');

      ctrl.vehicleService.getVehicle(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.vehicleId)
        .then(response => {
          Object.assign(ctrl.vehicle, response.data);

          ctrl.vehicle.firstRegistration = ctrl.utilsService.getDatePart(ctrl.vehicle.firstRegistration);
          ctrl.vehicle.dueInStock = ctrl.utilsService.getDatePart(ctrl.vehicle.dueInStock);
          
          this.configureForm();

          this.populateExtras();

          this.showMazdaServiceHistory();
          this.$scope.$broadcast('vehicle:initialized');
        })
        .catch(err => {

        })
        .finally(() => {
          ctrl.loadingService.hideLoading('editVehicle');
        })
    }
  }

  editVehicle() {
    var ctrl = this;

    if (!ctrl.formValidationService.validateForm()) { return; }

    this.state = 'Saving';

    ctrl.loadingService.showLoading('editVehicle', 'Saving Changes ...');

    //massage data
    if (typeof ctrl.vehicle.brandModel === 'string'){
      ctrl.vehicle.brandModel = null;
    }

    //Convert New Extras Format into Vehicle Extras
    this.convertToVehicleExtras();
    
    //Get the Images in Right Order
    this.getImagesInOrder();

    ctrl.vehicleService.editVehicle(ctrl.vehicle)
      .then(response => {
        this.state = 'Saved';
        let vehicleConditionSearch = null;

        if (ctrl.vehicle.vehicleCondition === ctrl.enums.VEHICLE_CONDITION.New)
        {
          vehicleConditionSearch = ctrl.enums.VEHICLE_CONDITION_SEARCH.New;
        }
        else {
          if (ctrl.vehicle.autoSold === ctrl.enums.AUTO_SOLD.Retail) {
            vehicleConditionSearch = ctrl.enums.VEHICLE_CONDITION_SEARCH.UsedRetail;
          }
          else {
            vehicleConditionSearch = ctrl.enums.VEHICLE_CONDITION_SEARCH.UsedTrade;
          }
        }

        ctrl.redirectToParent(vehicleConditionSearch, response.data);
      })
      .catch(err => {
        if (err.status === 400) { //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(item => {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        }
        else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('editVehicle');
      });
  }

  redirectToParent(vehicleConditionSearch, vehicleId) {
    if (!this.origin.source) {
      this.$state.go('vehicleList', {vehicleConditionSearch: vehicleConditionSearch});
    }
    else if (this.origin.source === 'enquiry') {
      this.$state.go('enquiryEdit', {
        enquiryId: this.origin.enquiryId,
        activeTab: 'vehicles'
      });
    }
    else if (this.origin.source === 'editFinance') {
      this.$state.go('financeEdit', {
        financeId: this.origin.financeId
      });
    }    
    else if (this.origin.source === 'vehiclePublish') {
      this.$state.go('vehiclePublish');
    }            
    else {
      const output = this.origin.processResult(vehicleId, this.vehicle);

      this.$state.go(output.stateName, output.params);
    }
  }

  childComponentsReady() {
    this.loadVehicle();
  }

  easierAd() {
    this.vehicleService.easierAd(this.authService.authData.currentLocation.key);
  }

  updateExternal() {
    if (this.vehicle.vehicleId) {
      let color = '';

      if (this.vehicle.color){
        color = _find(this.enumLookupCollection.color, o => o.id === this.vehicle.color).name
      }

      this.$state.go('vehicleEditSkupenet', {
        skupenetId: this.vehicle.skupenetId,
        price: this.vehicle.price,         
        color: color,
      });
    }
    else{
      this.$state.go('vehicleAddSkupenet', {
        registration: this.vehicle.registration,
        vehicleCondition: this.vehicle.vehicleCondition === this.enums.VEHICLE_CONDITION.Used ? this.enums.VEHICLE_CONDITION.Used : this.enums.VEHICLE_CONDITION.New,
        autoSold: this.vehicle.autoSold,
        vehicleStatus: this.vehicle.state,
      });
    }
    
  }

  initializeExtras() {
    this.keyValueFields.map((field) => {
      this.extras[field] = null;
    })
  }

  populateExtras() {
    if (this.vehicle && this.vehicle.extras.length) {
      this.vehicle.extras.map((ext) => {
        this.extras[ext.key] = ext.value;
      });
    }
  }

  convertToVehicleExtras() {
    _map(this.extras, (val, key) => {

      const vehExt = _find(this.vehicle.extras, o => o.key === key);

      /*
      * Case1: If Vehicle Extra Exists and value is not null
      * Update the Vehicle Extra with the new Value
      * */
      if (vehExt && val){
        vehExt.value = val;
      }

      /*
      * Case2: If Vehicle Extra Exists and value is null
      * User wants to remove the Vehicle Extra Value
      * So we can remove it from the final list 
      * as it will not be saved back in db and save some space
      * */
     if (vehExt && !val) {
       this.vehicle.extras = _without(this.vehicle.extras, vehExt);
     }

      /*
      * Case3: If Vehicle Extra Does Not Exists and value is not null
      * User wants to enter a new Extra so we need to add it to the collection
      * */
     if (!vehExt && val) {
       this.vehicle.extras.push({
         key: key,
         value: val
       });
     }

      /*
      * Case4: If Vehicle Extra Does Not Exists and value is null
      * No need to do anything here
      * */
    });    
  }

  getImagesInOrder() {
    if (this.vehicle.mediaItems && this.vehicle.mediaItems.length) {
      const video = _find(this.vehicle.mediaItems, mi => mi.mediaType === this.enums.MEDIA_TYPE.Youtube);
      let mediaItems = [];

      const $imagesInOrder = $('.imgGallery');
      
      _map($imagesInOrder, (el, ind) => {        
        const imgUrl = $(el).attr('src');        
        let img = _find(this.vehicle.mediaItems, mi => mi.url === imgUrl);

        if (!img) {
          img = _find(this.vehicle.mediaItems, mi => mi.tempUrl === imgUrl);
        }

        img.order = ind + 1;
        img.isCover = false;

        mediaItems.push(img);
      });

      if (video) {
        mediaItems.push(video);
      }

      //Set The First Image as Cover Image
      const firstImage = _find(mediaItems, mi => mi.mediaType === this.enums.MEDIA_TYPE.Image || mi.mediaType === this.enums.MEDIA_TYPE.ExternalImage);
      if (firstImage) {
        firstImage.isCover = true;
      }

      this.vehicle.mediaItems = mediaItems;
    }
  }

  onLookupVehicleSelected() {
    this.populateExtras();
    this.showMazdaServiceHistory();
  }

  showMazdaServiceHistory() {
    this.lookupService.lookupBrands()
      .then(brands => {
        const mazdaBrand = _find(brands, b => b.name.toLowerCase() === 'mazda');

        this.$scope.$broadcast('vehicleEdit:lookupVehicleSelected', {chassisNo: this.vehicle.chassisNo, isMazda: this.vehicle.brandId == mazdaBrand.brandId});
      });    
  }
}

export default VehicleEditController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleEdit.controller.js